import { IntlShape } from 'react-intl';
import { TypedLazyQueryTrigger } from '@reduxjs/toolkit/query/react';

import type { BaseQuery } from 'types/Request';
import type { AbstractMedia } from 'types/AbstractMedia';
import useLabelTranslation from 'hooks/useLabelTranslation';
import type { SignatureStatus } from 'modules/selfServices/types/SelfService';
import type { CreatePdfPreviewRequest } from 'modules/selfServices/types/CreatePdfPreview';

export interface SignDocument extends AbstractMedia {
  read: boolean;
  isVisible?: boolean;
  status: SignatureStatus;
  get?: TypedLazyQueryTrigger<string, CreatePdfPreviewRequest, BaseQuery>;
}

export enum DocumentKeys {
  SUMMARY = 'SUMMARY',
  WORK_ORDER = 'WORK_ORDER',
  MOBILITY = 'MOBILITY',
  DELIVERY_DOCUMENT = 'DELIVERY_DOCUMENT',
}

export interface DocumentOptions {
  intl?: IntlShape;
  getLabelTranslation?: ReturnType<typeof useLabelTranslation>['getLabelTranslation'];
  hasAcceptedMobility?: boolean;
  retrieveSummaryDocument?: TypedLazyQueryTrigger<string, CreatePdfPreviewRequest, BaseQuery>;
}
